import type { UsageProductInput } from '@vy/types';
import { isNotNullOrUndefined, purge } from '@vy/utils';
import { flatMap } from 'lodash';
import { Controller, get, useFormContext } from 'react-hook-form';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { ProductSourceSelect } from '../../UsageCharges/usage-charges-components/ProductSourceSelect/ProductSourceSelect';
import { useMeters } from '../../../../../../hooks/requests/use-meters/use-meters';
import { creditTypeIdsFromSource } from '../../shared/credit-type-ids-from-source';

type MeteredCreditProductSourceSelectProps = {
  meteredCredit: UsageProductInput;
};

export const MeteredCreditProductSourceSelect: React.FC<MeteredCreditProductSourceSelectProps> = ({
  meteredCredit,
}) => {
  const {
    control,
    getFieldState,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext<PlanInputForm>();
  const {
    data: { meters },
  } = useMeters();
  const usageProducts = watch('usageProducts') ?? [];
  const selectedMetersIds = purge(
    flatMap(usageProducts, ({ variants }) => variants.map(({ meterId }) => meterId)),
  );
  const productIndex = usageProducts.findIndex((usageProduct) => usageProduct.id === meteredCredit.id);

  return (
    <Controller
      control={control}
      name={`usageProducts.${productIndex}.variants.0.meterId`}
      render={({ field }) => (
        <ProductSourceSelect
          label=""
          error={isNotNullOrUndefined(get(errors, `usageProducts.${productIndex}.variants.0.meterId`))}
          helperText={getFieldState(`usageProducts.${productIndex}.variants.0.meterId`).error?.message}
          value={field.value}
          selectedMetersIds={selectedMetersIds}
          onChange={(event, newValue) => {
            event.preventDefault();
            const meter = meters.find(({ id }) => id === newValue);
            setValue(`usageProducts.${productIndex}.creditTypeIds`, creditTypeIdsFromSource(meter));
            field.onChange(newValue);
          }}
        />
      )}
    />
  );
};
